export default __webpack_public_path__ + "6e6d16ea51aa38c6b9e44d812f279ab8.png";